import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'

import { Message } from 'primereact/message'
import { ProgressBar } from 'primereact/progressbar'

import { useFileContent, useThemeJson } from '../../data/tenantfiles'
import { useAllTenantFiles, useFile } from '../../data/tenantfiles/hooks'

interface ThemeContextProviderProps {
  children?: React.ReactNode
}

export type ThemeContextType = {
  theme: string
  imageBase64: string
}

const initValue: ThemeContextType = {
  theme: '',
  imageBase64: '',
}

export const ThemeContext = React.createContext<ThemeContextType>(initValue)

const ThemeContextProvider: React.FC<ThemeContextProviderProps> = ({ children }) => {
  const { data: filelist } = useAllTenantFiles()

  const { data: themeJson } = useThemeJson('cockpit/branding/theme.json')

  const { data, isLoading, error } = useFileContent(
    themeJson?.css?.isEnabled ? (themeJson?.css?.path as string) : null,
  )

  const { data: logo } = useFile(
    themeJson?.logo?.isEnabled ? (themeJson?.logo?.path as string) : null,
  )

  const [theme, setTheme] = useState('')

  const [imageBase64, setImageBase64] = useState('')

  useEffect(() => {
    if (data) {
      setTheme(data)
    }
    if (logo) {
      const reader = new FileReader()
      reader.readAsDataURL(logo)
      reader.onload = function () {
        setImageBase64(reader.result as string)
      }
    }
  }, [data, logo, themeJson])

  if (isLoading) return <ProgressBar mode="indeterminate" />
  if (error)
    return (
      <Message
        className="grid w-full justify-content-start"
        severity="error"
        text={`Error: ${error.message || 'Unknown error'}`}
      ></Message>
    )

  return (
    <ThemeContext.Provider value={{ theme, imageBase64 }}>
      <Helmet>
        <style>
          {themeJson?.css?.isEnabled &&
          filelist?.some(e => e.uri.includes(themeJson.css?.path as string))
            ? theme
            : ''}
        </style>
      </Helmet>
      <>{children}</>
    </ThemeContext.Provider>
  )
}

export default ThemeContextProvider
